import React, { useEffect, useState } from "react";
import Logo from "../assets/icons/logo.svg";
import AvatarGroup from "../assets/icons/Avatar group.svg";
import PrimaryBtn from "../components/partials/btn";
import Done from "../assets/icons/_Step icon base_done.svg";
import Pending from "../assets/icons/_Step icon base.svg";
import Input from "../components/partials/inputs";
import Plus from "../assets/icons/plus.svg";
import SuccessModal from "../components/modals/successmodal";
import Stepper from "../components/partials/steps";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useAuthStore from "../data/stores/authStore";
import { apiCall } from "../data/useFetcher";
import useErrorStore from "../data/stores/errorStore";
import toast from "react-hot-toast";
import { Controller, useForm } from "react-hook-form";
import { FaChevronLeft, FaTrash } from "react-icons/fa6";

export const removeUndefined = obj => {
	Object.keys(obj).forEach(
		key => (obj[key] === undefined || obj[key] === "") && delete obj[key]
	);
	return obj;
};

export const MainInvitation = () => {
	const [modal, setModal] = useState(true);
	const [successmodal, setSuccessmodal] = useState(false);
	const [activeStep, setActiveStep] = useState(1);
	const steps = [
			{
				id: 1,
				title: "Choose a password",
				description: "Choose a secure password",
				isClickAble: false,
			},
			{
				id: 2,
				title: "Invite your team",
				description: "Start collaborating with your team",
				isClickAble: false,
			},
		],
		[actualSteps, setSteps] = useState(steps);

	const [getSearch] = useSearchParams(),
		{ user } = useAuthStore(),
		navigate = useNavigate(),
		[loading, setLoading] = useState(false),
		{ returnErrors } = useErrorStore(),
		[thisUser, setUser] = useState<any>(null),
		location = useLocation()

	useEffect(() => {
		if (!getSearch?.get("email") && !user) {
			navigate("/");
		} else {
			let thisEmail = user?.user?.email;
			const emailRaw = location.search.match(/[?&]email=([^&]+)/)?.[1]; // get raw encoded value
			const email = decodeURIComponent(emailRaw?.replace(/\+/g, "%2B") || "");

			if (getSearch?.get("email")) thisEmail = email || getSearch?.get("email");
			let getAvailableUser = async () => {
				setLoading(true);

				let { response, errArr, errMsg } = await apiCall({
					type: "get",
					url: `/api/v1/auth/user/get-user-by-email?email=${encodeURIComponent(
						thisEmail
					)}&privilege=system owner`,
					noToast: true,
				});
				// console.log({ response, errArr, errMsg });
				if (errArr) {
					setLoading(false);
					returnErrors(errArr);
					navigate("/");
					return;
				}
				if (errMsg) {
					setLoading(false);
					toast.error(errMsg);
					navigate("/");
					return;
				}
				setLoading(false);
				if (response) {
					setUser(response?.data || response);
					// navigate("/");
					return;
				}
				setLoading(false);
			};
			getAvailableUser();
		}
	}, [getSearch]);

	useEffect(() => {
		if (thisUser) {
			let newSteps = [
				{
					id: 1,
					title: "Choose a password",
					description: "Choose a secure password",
					isClickAble: !thisUser?.password,
				},
				{
					id: 2,
					title: "Invite your team",
					description: "Start collaborating with your team",
					isClickAble: thisUser?.password,
				},
			];
			setSteps(newSteps);
			if (thisUser?.password) {
				setModal(false);
				setActiveStep(2);
			}
		}
	}, [thisUser]);
	// console.log({ actualSteps, steps });

	interface FormType {
		newPassword: string;
		confirmPassword: string;
	}

	const {
			control,
			handleSubmit,
			watch,
			formState: { errors },
		} = useForm({
			defaultValues: {
				newPassword: "",
				confirmPassword: "",
				oldPassword: "",
			},
		}),
		password = watch("newPassword");

	let onSubmit = async (data: FormType) => {
		setLoading(true);

		let newD: any = {
			...data,
			email: thisUser?.user?.email,
			user: thisUser?.user?._id,
		};

		const filtered = removeUndefined(newD);

		let { response, errArr, errMsg } = await apiCall({
			type: "post",
			url: `/api/v1/auth/user/update-password`,
			data: filtered,
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			setActiveStep(2);
			setUser(response?.data || response);
			return;
		}
		setLoading(false);
	};

	return (
		<div>
			{modal ? (
				<div className="fixed inset-0 bg-[#344054B2] flex justify-center items-center">
					<div className="bg-white modal-shadow w-[400px] rounded-xl p-6">
						<img src={AvatarGroup} alt="" className="mx-auto" />
						<h2 className="text-lg font-medium text-sec text-center">
							You’ve been added to the team!
						</h2>
						<p className="text-sm font-normal text-center text-es-gray-100">
							{user ? (
								<>Aggregating your profile details</>
							) : (
								<>
									Thanks for accepting the invite. You’ve now been added to the
									team
								</>
							)}{" "}
							as an editor.
						</p>
						<div className="mt-5">
							<PrimaryBtn
								onClick={() => setModal(false)}
								text="Get started"
								width="w-full"
								loading={loading}
							/>
						</div>
					</div>
				</div>
			) : (
				<div className="h-screen relative w-full flex">
					<div className="w-[30%] h-full bg-[#2070B8] p-8">
						<img src={Logo} alt="" className="" />
						{user && (
							<div className="my-4">
								<div
									onClick={() => navigate("/dashboard")}
									className="bg-[#E8EEF3] mt-3 main-shadow main-border h-14 items-center w-56 rounded-lg flex justify-center gap-4 cursor-pointer">
									<FaChevronLeft />
									<span className="text-base font-medium text-[#3F516C]">
										Dashboard
									</span>
								</div>
							</div>
						)}
						<div className="mt-12 flex gap-6">
							<div className="flex flex-col items-center">
								{actualSteps?.map((step, index) => (
									<div key={step.id} className="flex items-center">
										<div className="w-8">
											{activeStep === step?.id ? (
												<img src={Done} alt="" className="" />
											) : (
												<img src={Pending} alt="" className="" />
											)}
											{index < actualSteps.length - 1 && (
												<div className="h-10 w-0.5 my-2 mx-auto bg-gray-300"></div>
											)}
										</div>
									</div>
								))}
							</div>
							<div className="space-y-10">
								{actualSteps.map(step => (
									<div
										key={step.id}
										className={`cursor-pointer`}
										onClick={() => {
											if (step?.isClickAble) setActiveStep(step.id);
										}}>
										<h2 className="text-base font-medium text-white">
											{step.title}
										</h2>
										<p className="text-base font-normal text-white">
											{step.description}
										</p>
									</div>
								))}
							</div>
						</div>
					</div>
					<div
						className={`w-[70%] min-h-full overflow-y-visible bg-white p-10 relative flex items-center ${
							activeStep === 1 && "justify-center"
						}`}>
						{activeStep === 1 ? (
							<div>
								<h2 className="text-3xl font-semibold text-sec">
									Choose Password
								</h2>
								<p className="mt-1 text-sm text-es-gray-100 font-normal">
									Must be at least 8 characters.
								</p>

								<form onSubmit={handleSubmit(onSubmit)} className="mt-6">
									<div className="space-y-4 w-96">
										{thisUser?.password && (
											<div>
												<Controller
													name="oldPassword"
													control={control}
													rules={{
														required: thisUser?.password
															? "This field is required"
															: "",
														pattern: {
															value:
																/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/g,
															message:
																"Your password must have at least one uppercase letter, one lowercase letter, one digit, one special character, and a minimum length of 8 characters.",
														},
													}}
													render={({ field: { value, onChange, name } }) => (
														<Input
															type="password"
															value={value}
															onChange={onChange}
															name={name}
															label="Current Password*"
															placeholder="Current Password"
														/>
													)}
												/>
												{errors.oldPassword && (
													<p className="text-[#dc2626] text-xs">
														{errors.oldPassword.message}
													</p>
												)}
											</div>
										)}
										<div>
											<Controller
												name="newPassword"
												control={control}
												rules={{
													required: "This field is required",
													pattern: {
														value:
															/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/g,
														message:
															"Your password must have at least one uppercase letter, one lowercase letter, one digit, one special character, and a minimum length of 8 characters.",
													},
												}}
												render={({ field: { value, onChange, name } }) => (
													<Input
														type="password"
														value={value}
														onChange={onChange}
														name={name}
														label="Password*"
														placeholder="Choose a password"
														footer="Must be at least 8 characters."
													/>
												)}
											/>
											{errors.newPassword && (
												<p className="text-[#dc2626] text-xs">
													{errors.newPassword.message}
												</p>
											)}
										</div>
										<div>
											<Controller
												name="confirmPassword"
												control={control}
												rules={{
													required: "This field is required",
													pattern: {
														value:
															/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/g,
														message:
															"Your password must have at least one uppercase letter, one lowercase letter, one digit, one special character, and a minimum length of 8 characters.",
													},
													validate: value =>
														value === password || "Passwords do not match",
												}}
												render={({ field: { value, onChange, name } }) => (
													<Input
														type="password"
														value={value}
														onChange={onChange}
														name={name}
														label="Confirm Password*"
														placeholder="Confirm Password"
														footer="Ensure password match the other"
													/>
												)}
											/>
											{errors.confirmPassword && (
												<p className="text-[#dc2626] text-xs">
													{errors.confirmPassword.message}
												</p>
											)}
										</div>
									</div>
									<div className="mt-6 w-96">
										<PrimaryBtn
											text="Continue"
											width="w-full"
											type="submit"
											loading={loading}
										/>
									</div>
								</form>
							</div>
						) : (
							<SelectDepartment
								setSuccessmodal={setSuccessmodal}
								thisUser={thisUser}
							/>
						)}
						<div className="absolute bottom-7 left-1/2 transform -translate-x-1/2 w-full">
							<div className="w-full flex justify-center items-center">
								<Stepper
									activeStep={activeStep}
									setActiveStep={setActiveStep}
									totalSteps={steps?.length}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
			{successmodal && (
				<SuccessModal
					title="Selection Completed"
					btnText="Done"
					page="/login"
					desc="This invitation has been sent successfully. Focal persons will be able to complete assessment."
				/>
			)}
		</div>
	);
};

const Invitation = () => <MainInvitation />;

export default Invitation;

export const SelectDepartment = ({
	setSuccessmodal,
	thisUser,
}: {
	setSuccessmodal: (v: boolean) => void;
	thisUser: any;
}) => {
	// const [inputs, setInputs] = useState([
	// 	{
	// 		label: "Department*",
	// 		placeholder: "Enter Department",
	// 	},
	// 	{
	// 		label: "Focal Person*",
	// 		placeholder: "Enter Email",
	// 	},
	// 	{
	// 		label: "ERP Modules / Data Systems Used",
	// 		placeholder: "Enter Module",
	// 	},
	// 	{
	// 		label: "Department*",
	// 		placeholder: "Enter Department",
	// 	},
	// 	{
	// 		label: "Focal Person*",
	// 		placeholder: "Enter Email",
	// 	},
	// 	{
	// 		label: "ERP Modules / Data Systems Used",
	// 		placeholder: "Enter Module",
	// 	},
	// ]);

	let init = [
			{
				label: "Department*",
				placeholder: "Enter Department",
				name: "departmentName",
			},
			{
				label: "Focal Person*",
				placeholder: "Enter Email",
				name: "email",
			},
			{
				label: "ERP Modules / Data Systems Used",
				placeholder: "Enter Module",
				name: "erpModule",
			},
		],
		init2 = {};
	const [itemForm, setItemForm] = useState([init2]);
	const handleInputChangeForMutipleItem = (
		event: React.ChangeEvent<HTMLInputElement>,
		index: number,
		field: string
	) => {
		const { value } = event.target;
		let itemValue = value;

		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows[index][field] = itemValue;
			return newRows;
		});
	};

	const handleDeleteRowForMutipleItem = (index: number) => {
		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows.splice(index, 1);
			return newRows;
		});
	};

	const addRowForMutipleItem = () => {
		const newRow = init2;
		setItemForm([...itemForm, newRow]);
	};

	const [loading, setLoading] = useState(false),
		{ returnErrors } = useErrorStore(),
		handleSubmit = async (e: any) => {
			e?.preventDefault();
			console.log({ itemForm });

			setLoading(true);

			let { response, errArr, errMsg } = await apiCall({
				type: "put",
				url: `/api/v1/auth/user/manage-users/manage-team-members`,
				data: {
					members: itemForm,
					email: thisUser?.user?.email,
					user: thisUser?.user?._id,
				},
			});
			// console.log({ response, errArr, errMsg });
			if (errArr) {
				setLoading(false);
				return returnErrors(errArr);
			}
			if (errMsg) {
				setLoading(false);
				return toast.error(errMsg);
			}
			setLoading(false);
			if (response) {
				// setActiveStep(2);
				// setUser(response?.data || response);
				setSuccessmodal(true);
				return;
			}
			setLoading(false);
		};

	return (
		<>
			<div>
				<h2 className="text-3xl font-semibold text-sec">Select Department</h2>
				<p className="mt-1 text-sm text-es-gray-100 font-normal">
					Enter details correctly.
				</p>
				<form onSubmit={handleSubmit} className="mt-8">
					<div className="">
						<div>
							{itemForm?.map((item: any, i: number) => (
								<div className="grid grid-cols-3 gap-x-3 gap-y-5" key={i}>
									{init?.map((it, x) => (
										<div key={x} className="flex items-center">
											{x === 0 && itemForm?.length > 1 ? (
												<span
													className="mr-3 text-red-500 cursor-pointer"
													onClick={() => {
														if (itemForm?.length > 1)
															handleDeleteRowForMutipleItem(i);
													}}>
													<FaTrash />{" "}
												</span>
											) : (
												""
											)}
											<Input
												label={it?.label}
												placeholder={it?.placeholder}
												name={it?.name}
												value={item?.[it?.name]}
												type={it?.name === "email" ? "email" : "text"}
												onChange={e =>
													handleInputChangeForMutipleItem(e, i, it?.name)
												}
											/>
										</div>
									))}
								</div>
							))}
						</div>
						<div
							onClick={addRowForMutipleItem}
							className="mt-4 cursor-pointer flex gap-1 items-center">
							<img src={Plus} alt="" className="" />
							<small className="text-sm text-primary font-normal">
								Add another
							</small>
						</div>
						<div className="mt-6 w-96">
							<PrimaryBtn
								text="Continue"
								width="w-full"
								onClick={handleSubmit}
								loading={loading}
							/>
						</div>
					</div>
				</form>
			</div>
		</>
	);
};
